import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import SoulAttends from '../components/SoulAttends';
import SoulEditOverlay from '../components/SoulEditOverlay';
import SoulEmails from '../components/SoulEmails';
import SoulFutureSignups from '../components/SoulFutureSignups';
import SoulInfo from '../components/SoulInfo';

const SoulDetailPage = () => {
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const { soulId } = useParams();

  return (
    <>
      <SoulEditOverlay id={soulId || ''} isOpen={isEditDialogOpen} onClose={() => setIsEditDialogOpen(false)} />
      <SoulInfo onEdit={() => setIsEditDialogOpen(true)} />
      <SoulFutureSignups />
      <SoulAttends />
      <SoulEmails />
    </>
  );
};

export default SoulDetailPage;
